import React from 'react';
import { motion } from 'framer-motion';
import { Insight } from '../../../types/Statistics';

interface InsightCardProps extends Insight {
  delay?: number;
}

export const InsightCard: React.FC<InsightCardProps> = ({
  title,
  description,
  icon: Icon,
  color,
  metrics,
  delay = 0
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow"
    >
      <div className="flex items-center gap-3 mb-4">
        <div className={`p-2 rounded-lg ${color}`}>
          <Icon size={20} className="text-white" />
        </div>
        <h4 className="font-semibold text-gray-800">{title}</h4>
      </div>
      
      <p className="text-gray-600 mb-4 text-sm">{description}</p>
      
      {metrics && metrics.length > 0 && (
        <div className="space-y-3">
          {metrics.map((metric, index) => (
            <div key={index} className="flex justify-between items-baseline">
              <span className="text-sm text-gray-500">{metric.label}</span>
              <span className={`font-semibold ${metric.highlight ? 'text-orange-500' : 'text-gray-700'}`}>
                {metric.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
};